import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const objectSharingRequestTrackerSaveFailureSlice = createSlice({
  name: 'objectSharingRequestTrackerSaveFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    objectSharingRequestTrackerSaveFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    objectSharingRequestTrackerSaveFailureClear(state) {
      return null; // action.payload;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { objectSharingRequestTrackerSaveFailureChange, objectSharingRequestTrackerSaveFailureClear } = objectSharingRequestTrackerSaveFailureSlice.actions;

// export the core reducer for the slice
export const objectSharingRequestTrackerSaveFailureReducer = objectSharingRequestTrackerSaveFailureSlice.reducer;

export default objectSharingRequestTrackerSaveFailureSlice.reducer;